import { styled } from '@mui/system';
import { Box, Chip } from '@mui/material';

export const StatusFilterContainer = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
}));

export const FilterChip = styled(Chip)(({ theme, selected }) => ({
    transition: 'all 0.2s ease-in-out',
    cursor: 'pointer',

    '&:hover': {
        transform: 'translateY(-1px)',
        boxShadow: theme.shadows[2],
    },

    ...(selected && {
        fontWeight: 600,
        boxShadow: theme.shadows[1],
    })
}));
